export default "__VITE_ASSET__CXeIHvmD__"